import { ResponseType } from 'axios';

import { Document } from '../../types/common.types';
import {
  CancelVideoUploadParams,
  DownloadDocumentRequest,
  UploadChunkRequestHeaders,
  UploadDocumentRequest,
  UploadDocumentRequestHeaders
} from './document.types';

import {
  API_HOST,
  DOCUMENT_API_HOST,
  HttpGetOptions,
  HttpPostOptions,
  getHttpGetOptions,
  getHttpPostOptions
} from '../../utils/api.util';

const getEndpoint = () => `${DOCUMENT_API_HOST}`;
const getSpecificEndpoint = (documentExternalReference: string) => `${getEndpoint()}/${documentExternalReference}`;

export const getDownloadDocumentRequest = (
  data: DownloadDocumentRequest,
  responseType: ResponseType
): [string, HttpGetOptions] => [
  getSpecificEndpoint(data.documentExternalReference),
  getHttpGetOptions({ documentExternalReference: data.documentExternalReference }, undefined, responseType)
];

export const getUploadDocumentRequest = (
  data: UploadDocumentRequest,
  headers: UploadDocumentRequestHeaders
): [string, HttpPostOptions<Document>] => [getEndpoint(), getHttpPostOptions(data, headers)];

export const getUploadChunkRequest = (
  chunk: FormData,
  headers: UploadChunkRequestHeaders
): [string, HttpPostOptions<FormData>] => [`${API_HOST}/videos/chunk`, getHttpPostOptions(chunk, headers)];

export const getCancelVideoUploadRequest = (params: CancelVideoUploadParams): [string, HttpPostOptions<undefined>] => [
  `${API_HOST}/videos/uploads/cancel`,
  getHttpPostOptions(undefined, undefined, params)
];
